import React from 'react';
import Settings from './Settings';

const SettingsPage = () => {
  return <Settings />;
};

export default SettingsPage; 